var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 30.6654C16 30.6654 28 22.6654 28 13.332C28 10.1494 26.7357 7.09719 24.4853 4.84675C22.2348 2.59631 19.1826 1.33203 16 1.33203C12.8174 1.33203 9.76515 2.59631 7.51472 4.84675C5.26428 7.09719 4 10.1494 4 13.332C4 22.6654 16 30.6654 16 30.6654ZM20 13.332C20 15.5412 18.2091 17.332 16 17.332C13.7909 17.332 12 15.5412 12 13.332C12 11.1229 13.7909 9.33203 16 9.33203C18.2091 9.33203 20 11.1229 20 13.332Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 16,
    y1: 1.33203,
    x2: 16,
    y2: 30.6654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72A2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBD4FD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigLocation);
export default __webpack_public_path__ + "static/media/BigLocation.6806cbdf.svg";
export { ForwardRef as ReactComponent };